var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pdfUrl)?_c('div',{staticClass:"pdf-container"},[_c('iframe',{ref:"pdfIframe",staticStyle:{"width":"100%","height":"600px","border":"1px solid #ccc"},attrs:{"src":_vm.pdfUrl,"frameborder":"0"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }